var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSparkel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.989 2.85934C9.0208 2.68908 9.11115 2.53531 9.24439 2.42465C9.37763 2.31399 9.54537 2.25342 9.71857 2.25342C9.89177 2.25342 10.0595 2.31399 10.1928 2.42465C10.326 2.53531 10.4163 2.68908 10.4481 2.85934L11.2282 6.98441C11.2836 7.27769 11.4261 7.54745 11.6372 7.75849C11.8482 7.96954 12.118 8.11206 12.4112 8.16746L16.5363 8.9475C16.7066 8.9793 16.8603 9.06964 16.971 9.20288C17.0816 9.33612 17.1422 9.50387 17.1422 9.67707C17.1422 9.85027 17.0816 10.018 16.971 10.1513C16.8603 10.2845 16.7066 10.3748 16.5363 10.4066L12.4112 11.1867C12.118 11.2421 11.8482 11.3846 11.6372 11.5956C11.4261 11.8067 11.2836 12.0765 11.2282 12.3697L10.4481 16.4948C10.4163 16.6651 10.326 16.8188 10.1928 16.9295C10.0595 17.0401 9.89177 17.1007 9.71857 17.1007C9.54537 17.1007 9.37763 17.0401 9.24439 16.9295C9.11115 16.8188 9.0208 16.6651 8.989 16.4948L8.20896 12.3697C8.15356 12.0765 8.01104 11.8067 7.8 11.5956C7.58895 11.3846 7.31919 11.2421 7.02592 11.1867L2.90084 10.4066C2.73058 10.3748 2.57681 10.2845 2.46615 10.1513C2.3555 10.018 2.29492 9.85027 2.29492 9.67707C2.29492 9.50387 2.3555 9.33612 2.46615 9.20288C2.57681 9.06964 2.73058 8.9793 2.90084 8.9475L7.02592 8.16746C7.31919 8.11206 7.58895 7.96954 7.8 7.75849C8.01104 7.54745 8.15356 7.27769 8.20896 6.98441L8.989 2.85934Z",
    stroke: "#EFB100",
    strokeWidth: 1.48438,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6562 2.25537V5.22412",
    stroke: "#EFB100",
    strokeWidth: 1.48438,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1406 3.73975H14.1719",
    stroke: "#EFB100",
    strokeWidth: 1.48438,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78125 17.0991C4.60105 17.0991 5.26562 16.4345 5.26562 15.6147C5.26562 14.7949 4.60105 14.1304 3.78125 14.1304C2.96145 14.1304 2.29688 14.7949 2.29688 15.6147C2.29688 16.4345 2.96145 17.0991 3.78125 17.0991Z",
    stroke: "#EFB100",
    strokeWidth: 1.48438,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkel);
export default __webpack_public_path__ + "static/media/sparkel.a063b6bee1b8cc199290a972f9494d06.svg";
export { ForwardRef as ReactComponent };